import React, { useEffect, useReducer, useRef } from 'react';
import {
	Form,
	Button,
	Col,
	Table,
	Row,
	Select,
	DatePicker,
	Input,
	message,
} from 'antd';
import { AuditMarkingContext } from './context';
import {
	getAuditMarkingList,
	auditMarkingTodayPersonnelInformation,
	getAuditMarkingTagsList,
	getAuditMarkingGroupIns,
} from '../../../api/inspiration';
import { initState, reducer } from './reducer';
import * as actiontype from './reducer/action';
import '../AuditMarking/index.less';
import FunctionModal from './FunctionModal';
import WatchUpModal from './WatchUpModal';

const { Option } = Select;
const { RangePicker } = DatePicker;

export const auditStateList = [
	{
		value: 0,
		label: '未审核',
	},
	{
		value: 1,
		label: '已审核',
	},
];

function AuditMarking(props) {
	const [state, dispatch] = useReducer(reducer, initState);
	const { getFieldDecorator, getFieldValue } = props.form;
	const columns = [
		{
			title: '序号',
			key: 'id',
			dataIndex: 'id',
		},
		{
			title: '图片数量',
			key: 'insCount',
			dataIndex: 'insCount',
		},
		{
			title: '已打标签',
			key: 'hasTag',
			dataIndex: 'hasTag',
		},
		{
			title: '已评星级',
			key: 'hasStar',
			dataIndex: 'hasStar',
		},
		{
			title: '入库时间',
			key: 'storageTime',
			dataIndex: 'storageTime',
		},
		{
			title: '爬取来源',
			key: 'source',
			dataIndex: 'source',
		},
		{
			title: '最后审核人',
			key: 'reviewerId',
			dataIndex: 'reviewerId',
		},
		{
			title: '驳回数量',
			key: 'backCount',
			dataIndex: 'backCount',
		},
		{
			title: '操作',
			key: 'operation',
			render: (item) => {
				return (
					<>
						<Button
							type='primary'
							onClick={() => {
								getGroupIns(item, '打标签');
							}}
							disabled={item.insCount === item.hasTag}
						>
							打标签
						</Button>
						<Button
							type='primary'
							style={{
								backgroundColor: `${item.insCount !== item.hasTag
										? '#f5f5f5'
										: 'rgb(137, 191, 85)'
									}`,
								marginLeft: 15,
							}}
							onClick={() => getGroupIns(item, '评星级')}
							disabled={item.insCount !== item.hasTag || item.insCount === item.hasStar}
						>
							评星级
						</Button>
						<Button
							type='primary'
							style={{
								backgroundColor: `
										'rgb(137, 191, 85)'
								`,
								marginLeft: 15,
							}}
							onClick={() => getGroupIns(item, '查看')}
						>
							查看
						</Button>
					</>
				);
			},
		},
	];

	useEffect(() => {
		const init = async () => {
			await getDataSource();
			await getTodayData();
			await getStyleTagList();
			const username = localStorage.getItem('username');
			dispatch({
				type: actiontype.setData,
				data: {
					username,
				},
			});
			dispatch({
				type: actiontype.getTagsCache,
			});
		};
		init();
	}, []);

	useEffect(() => {
		const init = async () => {
			if (state.reflashList) {
				await queryData();
				dispatch({
					type: actiontype.setData,
					data: {
						reflashList: false,
					}
				});
			}
		}
		init();
	}, [state.reflashList])

	const getDataSource = async (data) => {
		if (!data) {
			data = {
				page: 1,
				pageSize: 10,
				hasReviewed: 0,
			};
		}
		dispatch({
			type: actiontype.setData,
			data: {
				functionModalLoading: true,
				tableLoading: true,
			},
		});
		const result = await getAuditMarkingList(data);
		if (result?.error?.code === 0) {
			const pageList = result?.data?.groupList ?? [];
			const total = Number(result?.data?.total ?? 0);
			const insCount = Number(result?.data?.insTotal ?? 0);
			const reviewedCount = Number(result?.data?.reviewedCount ?? 0);
			dispatch({
				type: actiontype.setData,
				data: {
					pageList,
					total,
					insCount,
					reviewedCount,
					functionModalLoading: false,
					tableLoading: false,
				},
			});
		} else {
			dispatch({
				type: actiontype.setData,
				data: {
					tableLoading: false,
					functionModalLoading: false,
				},
			});
			message.error('列表页接口错误!');
		}
	};

	// 获取审核人员今日数据
	const getTodayData = async () => {
		const username = localStorage.getItem('username');
		const result = await auditMarkingTodayPersonnelInformation(username + '');
		if (result?.error?.code === 0) {
			const personalInformation = result.data ?? {};
			dispatch({
				type: actiontype.setData,
				personalInformation,
			});
		} else {
			message.error('今日审核人员数据接口错误!');
		}
	};

	// 获取图片组数组
	const getGroupIns = async (item, tag) => {
		if (tag === '打标签') {
			const result = await getAuditMarkingGroupIns(item.id, true, true);
			if (result?.error?.code === 0) {
				const data = result.data ?? [];
				let newData = [];
				for (let v of data) {
					if (!v.tags) {
						newData.push(v);
					}
				}
				dispatch({
					type: actiontype.setData,
					data: {
						visible: true,
						insGroup: newData,
						modalTitle: '不通过图片',
						waterFallTitle: '步骤1/2：请选择不通过的图片',
						modalRightCount: item.removedCount,
						groupData: item,
						handleTagVisible: false,
						current: 0,
					},
				});
			} else {
				message.error('获取图片列表失败！');
			}
		} else if (tag === '评星级') {
			const result = await getAuditMarkingGroupIns(item.id, true, true);
			if (result?.error?.code === 0) {
				const data = result.data ?? [];
				const newData = [];
				for (let v of data) {
					if (!v.star) {
						newData.push(v);
					}
				}
				dispatch({
					type: actiontype.setData,
					data: {
						visible: true,
						insGroup: newData,
						modalTitle: '评星级',
						waterFallTitle: '步骤1/2：评一星',
						modalRightCount: item.hasStar,
						groupData: item,
						handleTagVisible: false,
						current: 2,
					},
				});
			}
		} else {
			const result = await getAuditMarkingGroupIns(item.id, true, true, 1);
			const watchUpModel = getFieldValue('status');
			if (result?.error?.code === 0) {
				const data = result.data ?? [];
				dispatch({
					type: actiontype.setData,
					data: {
						watchUpModalVisible: true,
						watchUpModalSource: data,
						groupData: item,
						virtualWaterUpdate: true,
						watchUpModel,
					},
				});
			}
		}
	};

	// 获取标签风格的大类
	const getStyleTagList = async () => {
		const result = await getAuditMarkingTagsList();
		if (result?.error?.code === 0) {
			const tags = result.data ?? [];
			dispatch({
				type: actiontype.setData,
				data: {
					tags,
				},
			});
			// setTags(result.data || []);
		} else {
			return message.error('标签风格列表接口异常！');
		}
	};

	// 列表页码变化监听函数
	const listPageChange = async (current, pageSize) => {
		await queryData(current, pageSize);
	};

	// 点击查询按钮的动作
	const queryData = async (page, pageSize) => {
		const { getFieldsValue, getFieldValue } = props.form;
		dispatch({
			type: actiontype.setData,
			data: {
				page,
			},
		});
		const values = getFieldsValue();
		const audit = getFieldValue('status');
		let parseData = {};
		if (audit === 0) {
			parseData = {
				startTime:
					values?.time?.[0]?.format('YYYY-MM-DD HH:00:00') ?? undefined,
				endTime: values?.time?.[1]?.format('YYYY-MM-DD HH:00:00') ?? undefined,
				hasReviewed: values.status,
				page: page ?? 1,
				pageSize: pageSize ?? 10,
			};
		} else {
			parseData = {
				startTime:
					values?.time?.[0]?.format('YYYY-MM-DD HH:00:00') ?? undefined,
				endTime: values?.time?.[1]?.format('YYYY-MM-DD HH:00:00') ?? undefined,
				reviewStartTime:
					values?.auditTime?.[0]?.format('YYYY-MM-DD HH:00:00') ?? undefined,
				reviewEndTime:
					values?.auditTime?.[1]?.format('YYYY-MM-DD HH:00:00') ?? undefined,
				hasReviewed: values.status,
				reviewerId: getFieldValue('auditorId'),
				page: page ?? 1,
				pageSize: pageSize ?? 10,
			};
		}
		await getDataSource(parseData);
	};

	return (
		<AuditMarkingContext.Provider
			value={{
				state,
				dispatch,
				queryData,
				getGroupIns,
			}}
		>
			<div className='auditMarking'>
				<div className='auditMarkingHeader'>审核打标</div>
				<div className='auditMarkingOperation'>
					<Form>
						<Row>
							<Col span={2}>
								<Form.Item>
									{getFieldDecorator('status', {
										initialValue: 0,
										rules: [
											{
												required: true,
												message: '请选择审核状态',
											},
										],
									})(
										<Select style={{ width: 130 }}>
											{auditStateList.map((item) => {
												return (
													<Option value={item.value} key={item.label}>
														{item.label}
													</Option>
												);
											})}
										</Select>
									)}
								</Form.Item>
							</Col>
							<Col span={6}>
								<Form.Item>
									入库时间：
									{getFieldDecorator('time', {
										rules: [
											{
												require: true,
												validator: (rule, value, callback) => {
													if (!value) {
														callback('请选择入库时间');
													}
												},
											},
										],
									})(
										<RangePicker
											showTime
											placeholder='请选择入库时间'
											format='YYYY-MM-DD HH:00:00'
											style={{
												width: '300px',
											}}
										/>
									)}
								</Form.Item>
							</Col>
							<Col span={6}>
								<Form.Item>
									审核时间：
									{getFieldDecorator('auditTime', {
										rules: [
											{
												require: true,
												validator: (rule, value, callback) => {
													if (!value) {
														callback('请选择审核时间');
													}
												},
											},
										],
									})(
										<RangePicker
											showTime
											placeholder='请选择入库时间'
											format='YYYY-MM-DD HH:00:00'
											style={{
												width: '300px',
											}}
										/>
									)}
								</Form.Item>
							</Col>
							<Col span={3}>
								<Form.Item>
									审核人id：
									{getFieldDecorator('auditorId', {
										rules: [
											{
												require: false,
											},
										],
									})(
										<Input
											style={{ width: 100 }}
											disabled={getFieldValue('status') === 0}
										/>
									)}
								</Form.Item>
							</Col>
							<Col span={3}>
								<Form.Item>
									<Button type='primary' onClick={() => queryData()}>
										查询
									</Button>
								</Form.Item>
							</Col>
							<Col span={2}>
								<span>查询结果: {state.insCount}</span>
							</Col>
							<Col span={2}>
								<span>已审核：{state.reviewedCount}</span>
							</Col>
						</Row>
					</Form>
				</div>
				<div className='auditMarkingTable'>
					<Table
						columns={columns}
						rowKey={(item) => item.id}
						dataSource={state.pageList}
						bordered
						loading={state.tableLoading}
						pagination={{
							total: state.total,
							onChange: listPageChange,
							pageSize: 10,
						}}
					/>
				</div>
			</div>
			<FunctionModal />
			<WatchUpModal />
		</AuditMarkingContext.Provider>
	);
}

const Index = Form.create({})(AuditMarking);
export default Index;
